package meineglasfaser.frontend.www.pages.explore

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.role
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.RouteInfo
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.navigation.Anchor
import io.ktor.http.*
import meineglasfaser.api.CustomerType
import meineglasfaser.api.routes.ShopRoutes
import meineglasfaser.frontend.common.BackendApi
import meineglasfaser.frontend.common.components.widgets.rememberQuery
import org.jetbrains.compose.web.dom.*

internal fun RouteInfo.customerTypeBy(name: String) = when (params.getValue(name)) {
    "business" -> CustomerType.COMPANY
    else -> CustomerType.INDIVIDUAL
}

@Page("{audience}")
@Layout(".components.layouts.ShopLayout")
@Composable
fun AudiencePage(ctx: PageContext) {
    val customerType = ctx.route.customerTypeBy("audience")

    val data = rememberQuery<ShopRoutes.Query.NetworkCategories.ResponseBody?>(null, ctx.route) {
        BackendApi.get(ShopRoutes.Query.NetworkCategories(customerType))
    }

    Div {
        when (customerType) {
            CustomerType.INDIVIDUAL -> {
                H1 { Text("Unser Angebot für Ihr Zuhause") }
                P { Text("Wählen Sie die gewünschte Verbindungsart für Ihr Internet:") }
            }
            CustomerType.COMPANY -> {
                H1 { Text("Unser Angebot für Ihr Unternehmen") }
                P { Text("Wählen Sie die gewünschte Verbindungsart für Ihr Unternehmen:") }
            }
        }
        Div({ classes("row-fluid") }) {
            data?.categories?.forEach { category ->
                Div({ classes("col-12", "col-lg-6") }) {
                    Article {
                        Header {
                            B { Text(category.title) }
                        }
                        Div(attrs = { classes("flex-column") }) {
                            Span { Text(category.summary) }
                        }
                        val url = URLBuilder().takeFrom(ctx.route.path).run {
                            appendPathSegments(category.id)
                            encodedPath
                        }
                        Anchor(href = url, attrs = { role("button") }) {
                            Text("Produkte entdecken")
                        }
                    }
                }
            }
        }
    }
}
